import { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';

export default function CTASection() {
  const [visible, setVisible] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) setVisible(true);
    }, { threshold: 0.2 });
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section ref={ref} className="relative py-24 overflow-hidden">
      <div className="absolute inset-0">
        <img
          alt="Bollywood Firki music studio CTA background"
          className="w-full h-full object-cover object-top"
          src="https://readdy.ai/api/search-image?query=Indian%20music%20recording%20studio%20aerial%20view%2C%20mixing%20console%20golden%20glow%2C%20professional%20music%20production%20environment%2C%20cinematic%20dark%20atmosphere%2C%20luxury%20studio%20interior%2C%20warm%20amber%20lighting&width=1920&height=600&seq=cta001&orientation=landscape"
        />
        <div className="absolute inset-0 bg-black/80"></div>
        <div className="absolute inset-0 bg-gradient-to-r from-[#0d0d0d] via-black/60 to-[#0d0d0d]"></div>
      </div>

      <div className="relative z-10 max-w-4xl mx-auto px-4 md:px-6 text-center">
        <div className={`transition-all duration-700 ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
          <div className="inline-flex items-center gap-3 mb-6">
            <span className="w-8 h-px bg-[#d4af37]"></span>
            <span className="text-[#d4af37] text-xs font-semibold tracking-[3px] uppercase">Start Your Journey</span>
            <span className="w-8 h-px bg-[#d4af37]"></span>
          </div>
          <h2 className="font-heading text-4xl md:text-6xl font-bold text-white mb-6">
            Ready to Create Your <span className="text-[#d4af37]">Musical Legacy?</span>
          </h2>
          <p className="text-white/70 text-lg md:text-xl leading-relaxed mb-10 max-w-2xl mx-auto">
            Join India's most prestigious music label. Whether you're an emerging artist or an established name, Bollywood Firki has the platform, expertise, and network to take your music to the world.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link to="/contact" className="inline-flex items-center justify-center gap-2 px-10 py-4 rounded-full text-base font-semibold text-black whitespace-nowrap btn-gold cursor-pointer transition-all hover:scale-105">
              Start Your Project <i className="ri-arrow-right-line"></i>
            </Link>
            <a href="tel:09990194423" className="inline-flex items-center justify-center gap-2 px-10 py-4 rounded-full text-base font-semibold text-white whitespace-nowrap border border-[#d4af37]/50 hover:border-[#d4af37] hover:bg-[#d4af37]/10 transition-all cursor-pointer">
              <i className="ri-phone-line"></i> Call Now
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
